import { gql } from '@apollo/client'

export const CHART1_2_QUERY = gql`
  query processingsTotalCount(
    $filter: ProcessingsTotalCountFilter
    $groupBy: ProcessingsTotalCountGroupBy
  ) {
    processingsTotalCount(filter: $filter, groupBy: $groupBy) {
      series {
        color
        title
        usersAverage
        serie {
          name
          date
          count
        }
      }
    }
  }
`
